import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { VisitType } from "@app/models/rest/visit-type";
import { VisitTypeRestService } from "@app/services/hal/visit-type-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class VisitTypeStore extends RealTimeDataStore<VisitType> {
  constructor() {
    const visitTypeRestService = inject(VisitTypeRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(visitTypeRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("VisitType");
  }
}
